// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"buttons_shadow__WCzt_","buttons":"buttons_buttons__2dYW-"};